import { List } from "immutable";

const findKeyPathOfNode = (tree, searchId) => {
  let path;
  if (List.isList(tree)) {
    tree.some((child, i) => {
      path = findKeyPathOfNode(child, searchId);
      if (path) {
        return path.unshift(i); // always returns truthy
      }
      return false;
    });
    return path;
  }
  if (tree.id === searchId) {
    return [];
  }
  path = findKeyPathOfNode(tree.get("children"), searchId);
  if (path) {
    return ["children"].concat(path);
  }
  return null;
};

export default findKeyPathOfNode;
